import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type ClientReservationActionsResponse = {
  canPayBalance: boolean
  canCancel: boolean
}

export function getClientReservationActions(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getClientReservationActions.url, { id }))
    .get<ClientReservationActionsResponse>()
}
